import { secondsToHours } from '@/common/utils/secondsToHours';

export const formatHours = (hours: number): string => {
  // `Number.EPSILON` corrects for binary floating-point representation error before rounding —
  // e.g. 1.005 * 100 evaluates to 100.49999999999999 without it, rounding down to 1h instead of
  // the intended 1.01h.
  const rounded = Math.round((hours + Number.EPSILON) * 100) / 100;
  return `${rounded}h`;
};

export const formatSecondsToHours = (seconds: number): string => {
  return formatHours(secondsToHours(seconds));
};
